import React from 'react';
import "../styles/work.css";

const Work = () => {
  return (
    <div id='work'>
        <div className='all-projects'>
            <h1 data-aos ='fade-up'>My Work</h1>
            <p data-aos ='fade-up'>Every project is a distinct piece of work.</p>
        </div>
        <div className='projects'>

            {/* FIRST PROJECT */}
            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/projectconsortium.png`} />
                </div>
                  <a href='https://projectconsortiumltd.com' target='blank' className='project-title'>Project Consortium</a>
            </div>
            {/* SECOND PROJECT */}
            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/gls.png`} />
                </div>

                  <a href='https://ghanalawsociety.org.gh' target='blank' className='project-title'>Ghana Law Society</a>
            </div>
            {/* SECOND PROJECT */}
            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/ghanabar.png`} />
                </div>

                  <a href='https://scarfoldgroupgh.com' target='blank' className='project-title'>LMS</a>
            </div>

            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/nextera.png`} />
                </div>

                  <a href='https://nskillshub.uk' target='blank' className='project-title'>NEXTERA LMS</a>
            </div>

            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/glitsons.png`} />
                </div>

                  <a href='https://glitsons.com' target='blank' className='project-title'>GLITSONS GLOBAL LTD</a>
            </div>

            {/* THIRD PROJECT */}
            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/naspaghana.png`} />
                </div>

                  <a href='https://naspaghana.org' target='blank' className='project-title'>NASPA Ghana Website</a>
            </div>
         
            {/* FIFTH PROJECT */}
            

            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/opaltech.png`} />
                </div>

                  <a href='https://opaltechafrica.com' target='blank' className='project-title'>Opaltech Ecommerce</a>
            </div>
            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/pennetwork.png`} />
                </div>

                 
                  <a href='https://pennetwork.net' target='blank' className='project-title'>Pennetwork</a>
            </div>

            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/flashit.png`} />
                </div>

                  <a href='https://jglitse.com' target='blank' className='project-title'>Flashit Ventures Site</a>
            </div>

               {/* FOURTH PROJECT */}
            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/tapcel.png`} />
                </div>

                  <a href='https://tapcel.jglitse.com' target='blank' className='project-title'>Laravel Ecommerce</a>
            </div>

            <div className='project-card'>
                <div className='project-img'>
                     <img src={`${process.env.PUBLIC_URL}/projects/buks.png`} />
                </div>

                <a href='https://buks.great-site.net' target='blank' className='project-title'>PHP Books Shop</a>
            </div>
        </div>
    </div>
  )
}

export default Work